export const TEMPLATE_PHONE_LISTING_PAGE = 'templatephonelistingpage';
export const TEMPLATE_PHONE_MANUFACTURER_PAGE = 'templatephonemanufacturerpage';
export const TEMPLATE_ACCESSORY_LISTING_PAGE = 'templateaccessorylistingpage';
export const TEMPLATE_USED_LISTING_PAGE = 'templateusedlistingpage';
export const TEMPLATE_PRODUCT_PAGE = 'templateproductpage';

export const COMPONENT_H1_HEADER = 'h1header';
export const COMPONENT_HEADER = 'header';
export const COMPONENT_TEXT = 'text';
export const COMPONENT_USP = 'usp';
export const COMPONENT_HERO = 'hero';
export const COMPONENT_LINK_AND_TEXT = 'linkandtext';
export const COMPONENT_FAMILY_SUBSCRIPTION_BUTTON = 'länk-familjabonnemang';
export const COMPONENT_FAMILY_DRAWER = 'familydrawer';
export const COMPONENT_FILTER_SECTION = 'filtersection';
export const COMPONENT_PRODUCT_LIST = 'productlistbycategory';
export const COMPONENT_SUBSCRIPTION_LIST = 'subscriptionlistbycategory';
export const COMPONENT_PRODUCT_SLIDER_BY_CATEGORY = 'productsliderbycategory';
export const COMPONENT_NOTIFICATION = 'notification';
export const COMPONENT_FAQ = 'faq';
export const COMPONENT_ACCORDION_START = 'accordionstart';
export const COMPONENT_ACCORDION_END = 'accordionend';
export const COMPONENT_ALIGNCENTER_START = 'aligncenterstart';
export const COMPONENT_ALIGNCENTER_END = 'aligncenterend';
export const COMPONENT_DRAWER_START = 'drawerstart';
export const COMPONENT_DRAWER_END = 'drawerend';
export const COMPONENT_LAYOUT_TWO_COLUMN_START = 'layouttwocolumnstart';
export const COMPONENT_LAYOUT_TWO_COLUMN_END = 'layouttwocolumnend';
export const COMPONENT_LAYOUT_TWO_COLUMN_INNER_START =
  'layouttwocolumninnerstart';
export const COMPONENT_LAYOUT_TWO_COLUMN_INNER_END = 'layouttwocolumninnerend';
export const COMPONENT_BANNER = 'toppageinfobanner';
export const COMPONENT_SIMPLE_HEADER_TEXT = 'simpleheadertext';
export const COMPONENT_SIMPLE_BULLET_LIST = 'simplebulletlist';
export const COMPONENT_SIMPLE_LINK = 'simplelink';
export const COMPONENT_MARGIN = 'margin';
export const COMPONENT_SIMPLE_IMAGE = 'simpleimage';
export const COMPONENT_POPUP = 'popup';
export const COMPONENT_CAMPAING_LABEL = 'campaignlabel';
export const COMPONENT_PRE_PAID_DATA = 'prepaiddatabycategory';
export const COMPONENT_PRE_PAID_PLANS = 'prepaidplans';
export const COMPONENT_CONTENT_BLOCK = 'contentblock';
export const COMPONENT_VALUATE_ONLY_BUYBACK = 'valuateonlybuyback';
export const COMPONENT_EMBEDDED_VIDEO = 'embeddedvideo';
export const COMPONENT_SEASONAL_DEALS_PRODUCT_CARDS =
  'seasonaldealsproductcards';
export const COMPONENT_SEASONAL_DEALS_SUBSCRIPTION_CARDS =
  'seasonaldealssubscriptioncards';
export const COMPONENT_CTA_LINK_CARDS = 'ctalinkcards';
